// src/connects/announces-tab.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import AnnouncesUnread from '../actions/announce-unread-flag'
import moment from 'moment'

export const mapStateToProps = (state, ownProps)=> {
  const announces = state.announce.announces
  const latest = state.announce.latest
  const close = state.announce.close
  const user = state.user.current
  return {
    announces: announces,
    latest: latest,
    close: close,
    user: user,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: (props)=> {
      /* announce_last_seen_atがnullの場合、以前の実装で既読情報をAnnouncesUnread.get/setで格納していたのでこちらの比較する*/
      if(props.user && !props.user.announce_last_seen_at) {
        AnnouncesUnread.get((currentDate) => {
          if(!currentDate){
            props.updateUI({ currentDate: moment(props.ui.currentDate).format('YYYY-MM-DD HH:mm:SS') })
          }else if(moment(props.ui.currentDate).isBefore(moment(currentDate))){
            props.updateUI({ currentDate: moment(currentDate).format('YYYY-MM-DD HH:mm:SS') })
          }
        })
      }
      /* announce_last_seen_atにデータがあり、ui.currnetDateよりも最新だった場合はこちらを格納する */
      if(props.user && props.user.announce_last_seen_at > props.ui.currentDate) {
        props.updateUI({ currentDate: props.user.announce_last_seen_at })
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      currentDate: '2021-01-01 00:00:00'
    }
  }),
  lifecycle,
  translate(),
  trackPage('notifications'),
)



// WEBPACK FOOTER //
// ./src/connects/announces-tab.js